export default __webpack_public_path__ + "static/media/welpentreffen_46.28dffe3c.jpg";